/**
 * Datos de muestra para curvas de crecimiento OMS
 * NOTA: Esta es una muestra reducida para desarrollo
 * Los datos completos LMS deben obtenerse de las tablas oficiales OMS
 */

// Datos LMS de muestra para peso/edad (niños 0-144 meses)
export const sampleWeightForAgeBoysLMS = [
  // age (months), L, M (median), S (coefficient of variation)
  { age: 0, sex: 'M', l: 0.3487, m: 3.3464, s: 0.14602 },
  { age: 1, sex: 'M', l: 0.2784, m: 4.4709, s: 0.13395 },
  { age: 2, sex: 'M', l: 0.2581, m: 5.5675, s: 0.12385 },
  { age: 3, sex: 'M', l: 0.2551, m: 6.3762, s: 0.11727 },
  { age: 4, sex: 'M', l: 0.2530, m: 6.8738, s: 0.11316 },
  { age: 5, sex: 'M', l: 0.2514, m: 7.3081, s: 0.11034 },
  { age: 6, sex: 'M', l: 0.2565, m: 7.9340, s: 0.11316 },
  { age: 7, sex: 'M', l: 0.2571, m: 8.2969, s: 0.11316 },
  { age: 8, sex: 'M', l: 0.2576, m: 8.6094, s: 0.11316 },
  { age: 9, sex: 'M', l: 0.2580, m: 8.9014, s: 0.11316 },
  { age: 10, sex: 'M', l: 0.2580, m: 9.1649, s: 0.11472 },
  { age: 11, sex: 'M', l: 0.2580, m: 9.4027, s: 0.11588 },
  { age: 12, sex: 'M', l: 0.2581, m: 9.6479, s: 0.11727 },
  { age: 15, sex: 'M', l: 0.2582, m: 10.2987, s: 0.12115 },
  { age: 18, sex: 'M', l: 0.2583, m: 10.8649, s: 0.12471 },
  { age: 21, sex: 'M', l: 0.2583, m: 11.3688, s: 0.12776 },
  { age: 24, sex: 'M', l: 0.2584, m: 12.1515, s: 0.11950 },
  { age: 30, sex: 'M', l: 0.2585, m: 13.4473, s: 0.13165 },
  { age: 36, sex: 'M', l: 0.2586, m: 14.6469, s: 0.13835 },
  { age: 42, sex: 'M', l: 0.2587, m: 15.7810, s: 0.14449 },
  { age: 48, sex: 'M', l: 0.2588, m: 16.8693, s: 0.15016 },
  { age: 60, sex: 'M', l: 0.2590, m: 19.2592, s: 0.16207 },
  { age: 72, sex: 'M', l: 0.2592, m: 21.9075, s: 0.17299 },
  { age: 84, sex: 'M', l: 0.2594, m: 24.8467, s: 0.18315 },
  { age: 96, sex: 'M', l: 0.2596, m: 28.1316, s: 0.19275 },
  { age: 108, sex: 'M', l: 0.2598, m: 31.8121, s: 0.20193 },
  { age: 120, sex: 'M', l: 0.2600, m: 35.9442, s: 0.21077 },
  { age: 132, sex: 'M', l: 0.2602, m: 40.5884, s: 0.21934 },
  { age: 144, sex: 'M', l: 0.2604, m: 45.8098, s: 0.22767 },
]

export const sampleWeightForAgeGirlsLMS = [
  { age: 0, sex: 'F', l: 0.3809, m: 3.2322, s: 0.14171 },
  { age: 1, sex: 'F', l: 0.3075, m: 4.1873, s: 0.13078 },
  { age: 2, sex: 'F', l: 0.2986, m: 5.1282, s: 0.12204 },
  { age: 3, sex: 'F', l: 0.2959, m: 5.8458, s: 0.11638 },
  { age: 4, sex: 'F', l: 0.2943, m: 6.2749, s: 0.11316 },
  { age: 5, sex: 'F', l: 0.2930, m: 6.6512, s: 0.11107 },
  { age: 6, sex: 'F', l: 0.2986, m: 7.2970, s: 0.11569 },
  { age: 7, sex: 'F', l: 0.2992, m: 7.6422, s: 0.11569 },
  { age: 8, sex: 'F', l: 0.2997, m: 7.9538, s: 0.11569 },
  { age: 9, sex: 'F', l: 0.3001, m: 8.2359, s: 0.11569 },
  { age: 10, sex: 'F', l: 0.3002, m: 8.4938, s: 0.11702 },
  { age: 11, sex: 'F', l: 0.3003, m: 8.7307, s: 0.11819 },
  { age: 12, sex: 'F', l: 0.3004, m: 8.9548, s: 0.11805 },
  { age: 15, sex: 'F', l: 0.3006, m: 9.5594, s: 0.12115 },
  { age: 18, sex: 'F', l: 0.3008, m: 10.0827, s: 0.12471 },
  { age: 21, sex: 'F', l: 0.3010, m: 10.5464, s: 0.12776 },
  { age: 24, sex: 'F', l: 0.3040, m: 11.5154, s: 0.12204 },
  { age: 30, sex: 'F', l: 0.3042, m: 12.7345, s: 0.13165 },
  { age: 36, sex: 'F', l: 0.3044, m: 13.8502, s: 0.13835 },
  { age: 42, sex: 'F', l: 0.3046, m: 14.8925, s: 0.14449 },
  { age: 48, sex: 'F', l: 0.3048, m: 15.8788, s: 0.15016 },
  { age: 60, sex: 'F', l: 0.3050, m: 18.0307, s: 0.16207 },
  { age: 72, sex: 'F', l: 0.3052, m: 20.4188, s: 0.17299 },
  { age: 84, sex: 'F', l: 0.3054, m: 23.0914, s: 0.18315 },
  { age: 96, sex: 'F', l: 0.3056, m: 26.0989, s: 0.19275 },
  { age: 108, sex: 'F', l: 0.3058, m: 29.4946, s: 0.20193 },
  { age: 120, sex: 'F', l: 0.3060, m: 33.3373, s: 0.21077 },
  { age: 132, sex: 'F', l: 0.3062, m: 37.6903, s: 0.21934 },
  { age: 144, sex: 'F', l: 0.3064, m: 42.6232, s: 0.22767 },
]

// Datos LMS de muestra para talla/edad (niños 0-144 meses)
export const sampleHeightForAgeBoysLMS = [
  { age: 0, sex: 'M', l: 1, m: 49.9887, s: 0.03936 },
  { age: 1, sex: 'M', l: 1, m: 54.7244, s: 0.03688 },
  { age: 2, sex: 'M', l: 1, m: 58.4249, s: 0.03551 },
  { age: 3, sex: 'M', l: 1, m: 61.4292, s: 0.03481 },
  { age: 4, sex: 'M', l: 1, m: 63.8855, s: 0.03430 },
  { age: 5, sex: 'M', l: 1, m: 65.9026, s: 0.03390 },
  { age: 6, sex: 'M', l: 1, m: 67.6239, s: 0.03379 },
  { age: 9, sex: 'M', l: 1, m: 70.5996, s: 0.03328 },
  { age: 12, sex: 'M', l: 1, m: 75.7488, s: 0.03117 },
  { age: 15, sex: 'M', l: 1, m: 78.0425, s: 0.03125 },
  { age: 18, sex: 'M', l: 1, m: 80.1741, s: 0.03149 },
  { age: 21, sex: 'M', l: 1, m: 82.1587, s: 0.03179 },
  { age: 24, sex: 'M', l: 1, m: 87.0756, s: 0.03216 },
  { age: 30, sex: 'M', l: 1, m: 91.2543, s: 0.03328 },
  { age: 36, sex: 'M', l: 1, m: 95.1423, s: 0.03441 },
  { age: 42, sex: 'M', l: 1, m: 98.8007, s: 0.03551 },
  { age: 48, sex: 'M', l: 1, m: 102.2722, s: 0.03656 },
  { age: 60, sex: 'M', l: 1, m: 109.0219, s: 0.03849 },
  { age: 72, sex: 'M', l: 1, m: 115.4974, s: 0.04017 },
  { age: 84, sex: 'M', l: 1, m: 121.7504, s: 0.04165 },
  { age: 96, sex: 'M', l: 1, m: 127.8264, s: 0.04295 },
  { age: 108, sex: 'M', l: 1, m: 133.7668, s: 0.04410 },
  { age: 120, sex: 'M', l: 1, m: 139.6063, s: 0.04512 },
  { age: 132, sex: 'M', l: 1, m: 145.3785, s: 0.04603 },
  { age: 144, sex: 'M', l: 1, m: 151.1162, s: 0.04685 },
]

export const sampleHeightForAgeGirlsLMS = [
  { age: 0, sex: 'F', l: 1, m: 49.1477, s: 0.03790 },
  { age: 1, sex: 'F', l: 1, m: 53.6872, s: 0.03568 },
  { age: 2, sex: 'F', l: 1, m: 57.0673, s: 0.03449 },
  { age: 3, sex: 'F', l: 1, m: 59.8029, s: 0.03393 },
  { age: 4, sex: 'F', l: 1, m: 62.0899, s: 0.03353 },
  { age: 5, sex: 'F', l: 1, m: 64.0301, s: 0.03322 },
  { age: 6, sex: 'F', l: 1, m: 65.7311, s: 0.03302 },
  { age: 9, sex: 'F', l: 1, m: 68.7462, s: 0.03268 },
  { age: 12, sex: 'F', l: 1, m: 74.0978, s: 0.03056 },
  { age: 15, sex: 'F', l: 1, m: 76.4064, s: 0.03070 },
  { age: 18, sex: 'F', l: 1, m: 78.5539, s: 0.03097 },
  { age: 21, sex: 'F', l: 1, m: 80.5547, s: 0.03131 },
  { age: 24, sex: 'F', l: 1, m: 85.7279, s: 0.03204 },
  { age: 30, sex: 'F', l: 1, m: 89.8548, s: 0.03322 },
  { age: 36, sex: 'F', l: 1, m: 93.6982, s: 0.03441 },
  { age: 42, sex: 'F', l: 1, m: 97.3078, s: 0.03557 },
  { age: 48, sex: 'F', l: 1, m: 100.7128, s: 0.03669 },
  { age: 60, sex: 'F', l: 1, m: 107.2756, s: 0.03874 },
  { age: 72, sex: 'F', l: 1, m: 113.5445, s: 0.04058 },
  { age: 84, sex: 'F', l: 1, m: 119.5638, s: 0.04225 },
  { age: 96, sex: 'F', l: 1, m: 125.3799, s: 0.04377 },
  { age: 108, sex: 'F', l: 1, m: 131.0386, s: 0.04516 },
  { age: 120, sex: 'F', l: 1, m: 136.5836, s: 0.04644 },
  { age: 132, sex: 'F', l: 1, m: 142.0587, s: 0.04763 },
  { age: 144, sex: 'F', l: 1, m: 147.5064, s: 0.04873 },
]

// Datos LMS de muestra para perímetro cefálico (0-60 meses)
export const sampleHeadCircumferenceBoysLMS = [
  { age: 0, sex: 'M', l: 1, m: 34.4618, s: 0.03264 },
  { age: 1, sex: 'M', l: 1, m: 37.2759, s: 0.02834 },
  { age: 2, sex: 'M', l: 1, m: 39.1285, s: 0.02649 },
  { age: 3, sex: 'M', l: 1, m: 40.5135, s: 0.02548 },
  { age: 4, sex: 'M', l: 1, m: 41.4637, s: 0.02492 },
  { age: 5, sex: 'M', l: 1, m: 42.2640, s: 0.02456 },
  { age: 6, sex: 'M', l: 1, m: 43.2611, s: 0.02456 },
  { age: 9, sex: 'M', l: 1, m: 44.7982, s: 0.02448 },
  { age: 12, sex: 'M', l: 1, m: 46.0685, s: 0.02456 },
  { age: 15, sex: 'M', l: 1, m: 47.1125, s: 0.02476 },
  { age: 18, sex: 'M', l: 1, m: 47.9847, s: 0.02500 },
  { age: 21, sex: 'M', l: 1, m: 48.7238, s: 0.02522 },
  { age: 24, sex: 'M', l: 1, m: 48.3180, s: 0.02526 },
  { age: 30, sex: 'M', l: 1, m: 49.5687, s: 0.02564 },
  { age: 36, sex: 'M', l: 1, m: 50.2156, s: 0.02598 },
  { age: 42, sex: 'M', l: 1, m: 50.7345, s: 0.02628 },
  { age: 48, sex: 'M', l: 1, m: 51.1532, s: 0.02654 },
  { age: 54, sex: 'M', l: 1, m: 51.4982, s: 0.02677 },
  { age: 60, sex: 'M', l: 1, m: 51.7891, s: 0.02697 },
]

export const sampleHeadCircumferenceGirlsLMS = [
  { age: 0, sex: 'F', l: 1, m: 33.8787, s: 0.03255 },
  { age: 1, sex: 'F', l: 1, m: 36.5463, s: 0.02834 },
  { age: 2, sex: 'F', l: 1, m: 38.2934, s: 0.02648 },
  { age: 3, sex: 'F', l: 1, m: 39.5328, s: 0.02547 },
  { age: 4, sex: 'F', l: 1, m: 40.4462, s: 0.02491 },
  { age: 5, sex: 'F', l: 1, m: 41.2187, s: 0.02456 },
  { age: 6, sex: 'F', l: 1, m: 42.2013, s: 0.02456 },
  { age: 9, sex: 'F', l: 1, m: 43.6789, s: 0.02448 },
  { age: 12, sex: 'F', l: 1, m: 44.8969, s: 0.02456 },
  { age: 15, sex: 'F', l: 1, m: 45.8765, s: 0.02476 },
  { age: 18, sex: 'F', l: 1, m: 46.6923, s: 0.02500 },
  { age: 21, sex: 'F', l: 1, m: 47.3894, s: 0.02522 },
  { age: 24, sex: 'F', l: 1, m: 47.1709, s: 0.02525 },
  { age: 30, sex: 'F', l: 1, m: 48.3456, s: 0.02564 },
  { age: 36, sex: 'F', l: 1, m: 48.9234, s: 0.02598 },
  { age: 42, sex: 'F', l: 1, m: 49.3987, s: 0.02628 },
  { age: 48, sex: 'F', l: 1, m: 49.7845, s: 0.02654 },
  { age: 54, sex: 'F', l: 1, m: 50.1098, s: 0.02677 },
  { age: 60, sex: 'F', l: 1, m: 50.3876, s: 0.02697 },
]

// Hitos del desarrollo por grupos etarios
export const developmentalMilestones = {
  '0-3': [
    { id: 1, description: 'Sonríe en respuesta', expectedAge: 2, critical: false },
    { id: 2, description: 'Sigue objetos con la mirada', expectedAge: 2, critical: true },
    { id: 3, description: 'Mantiene la cabeza erguida', expectedAge: 3, critical: true },
  ],
  '3-6': [
    { id: 4, description: 'Se ríe a carcajadas', expectedAge: 4, critical: false },
    { id: 5, description: 'Agarra objetos', expectedAge: 5, critical: true },
    { id: 6, description: 'Se voltea de boca arriba a boca abajo', expectedAge: 6, critical: true },
  ],
  '6-12': [
    { id: 7, description: 'Se sienta sin apoyo', expectedAge: 8, critical: true },
    { id: 8, description: 'Dice "mamá" o "papá"', expectedAge: 10, critical: true },
    { id: 9, description: 'Camina con apoyo', expectedAge: 12, critical: true },
  ],
  '12-24': [
    { id: 10, description: 'Camina solo', expectedAge: 15, critical: true },
    { id: 11, description: 'Dice al menos 10 palabras', expectedAge: 18, critical: true },
    { id: 12, description: 'Corre', expectedAge: 20, critical: false },
  ],
  '24-36': [
    { id: 13, description: 'Salta con ambos pies', expectedAge: 30, critical: false },
    { id: 14, description: 'Forma frases de 2-3 palabras', expectedAge: 24, critical: true },
    { id: 15, description: 'Controla esfínteres durante el día', expectedAge: 36, critical: false },
  ],
}

// Esquema de vacunación básico (MSP Ecuador)
export const vaccinationSchedule = [
  { vaccine: 'BCG', ageMonths: 0, required: true },
  { vaccine: 'Hepatitis B', ageMonths: 0, required: true },
  { vaccine: 'Pentavalente 1era dosis', ageMonths: 2, required: true },
  { vaccine: 'Rotavirus 1era dosis', ageMonths: 2, required: true },
  { vaccine: 'Neumocócica 1era dosis', ageMonths: 2, required: true },
  { vaccine: 'Pentavalente 2da dosis', ageMonths: 4, required: true },
  { vaccine: 'Rotavirus 2da dosis', ageMonths: 4, required: true },
  { vaccine: 'Neumocócica 2da dosis', ageMonths: 4, required: true },
  { vaccine: 'Pentavalente 3era dosis', ageMonths: 6, required: true },
  { vaccine: 'Rotavirus 3era dosis', ageMonths: 6, required: true },
  { vaccine: 'SRP (Sarampión, Rubéola, Paperas)', ageMonths: 12, required: true },
]

// Función helper para obtener datos LMS por parámetro
export const getWhoLMSData = (parameter, sex) => {
  const dataMap = {
    weight: sex === 'M' ? sampleWeightForAgeBoysLMS : sampleWeightForAgeGirlsLMS,
    height: sex === 'M' ? sampleHeightForAgeBoysLMS : sampleHeightForAgeGirlsLMS,
    headCircumference: sex === 'M' ? sampleHeadCircumferenceBoysLMS : sampleHeadCircumferenceGirlsLMS,
  }

  return dataMap[parameter] || []
}

// Función helper para obtener hitos según edad en meses
export const getMilestonesByAge = (ageInMonths) => {
  if (ageInMonths < 3) return developmentalMilestones['0-3']
  if (ageInMonths < 6) return developmentalMilestones['3-6']
  if (ageInMonths < 12) return developmentalMilestones['6-12']
  if (ageInMonths < 24) return developmentalMilestones['12-24']
  if (ageInMonths < 36) return developmentalMilestones['24-36']

  return [] // Después de 3 años, diferentes evaluaciones
}

export default {
  sampleWeightForAgeBoysLMS,
  sampleWeightForAgeGirlsLMS,
  sampleHeightForAgeBoysLMS,
  sampleHeightForAgeGirlsLMS,
  sampleHeadCircumferenceBoysLMS,
  sampleHeadCircumferenceGirlsLMS,
  developmentalMilestones,
  vaccinationSchedule,
  getWhoLMSData,
  getMilestonesByAge,
}
